import React, { useEffect, useState } from 'react'
import { useUser } from 'src/lib/contexts/UserContext'
import { Tooltip } from '@mui/material'
import { permissionType } from 'src/lib/utils/constants'
import { DivingFlippers } from 'mdi-material-ui'

interface PermissionServiceProps {
  permissionId: typeof permissionType[keyof typeof permissionType] | undefined
  children: JSX.Element
  hideElement?: boolean
  quantity?: number //Used to validate against permission max limit
  UnavailabilityReasonUI?: React.ReactNode
  UnavailabilityFallbackUI?: React.ReactNode
  customClass?: string
  message?: React.ReactNode
}

const Permission = ({
  permissionId,
  children,
  hideElement = false,
  quantity,
  UnavailabilityReasonUI = <></>,
  UnavailabilityFallbackUI,
  customClass,
  message
}: PermissionServiceProps) => {
  const { canAccess } = useUser()
  const [showDisclaimer, setShowDisclaimer] = useState<boolean>(false)

  useEffect(() => {
    const restrictedElems = document.querySelectorAll(`[data-restricted_element="${permissionId}"]`)
    if (!restrictedElems) return
    restrictedElems.forEach((el: any) => {
      el?.addEventListener(
        'click',
        function (event: any) {
          event.stopPropagation()
        },
        true // Add listener to *capturing* phase
      )
      el.childNodes?.forEach((ele: any) => (ele.style.cursor = 'not-allowed'))
    })
  }, [])

  if (!Boolean(permissionId)) {
    return children
  }

  const hasPermission = canAccess(permissionId as string, quantity ?? 0)

  if (hasPermission && children) {
    return children
  }

  if (hideElement) return <></>

  return (
    <div className={`${Boolean(customClass) && customClass}`}>
      {Boolean(UnavailabilityFallbackUI) ? (
        UnavailabilityFallbackUI
      ) : (
        <>
          <Tooltip title={message ?? 'Upgrade your plan to use'}>
            <div
              id={`restricted_element-${permissionId}`}
              className={`w-full cursor-not-allowed opacity-40 pointer-events-none`}
              data-restricted_element={permissionId}
              onClick={() => {
                setShowDisclaimer(true)
              }}
            >
              {children}
            </div>
          </Tooltip>

          {Boolean(showDisclaimer) && Boolean(UnavailabilityReasonUI) && UnavailabilityReasonUI}
        </>
      )}
    </div>
  )
}

export default React.memo(Permission)
